import path from 'node:path';
import { randomUUID } from 'node:crypto';
import { componentGenerator } from '@wix/gena';
import { toJsonString } from '@wix/cli-fs';
import { getSiteWidgetsDir, SITE_WIDGETS_DIR } from '@wix/cli-app-definitions';
import type { CustomElementConfig } from '@wix/cli-app-definitions';
import { normalizeGlobbyPattern } from '../../../../dev-center/components/path.js';

const CUSTOM_ELEMENT_TEMPLATE = path.resolve(
  __dirname,
  '../templates/custom-element'
);

export async function generateCustomElement(
  projectFolder: string,
  folder: string,
  name: string,
  dashboardPageId?: string
) {
  const readablePath = path.join(SITE_WIDGETS_DIR, folder);
  const cwd = path.join(getSiteWidgetsDir(projectFolder), folder);

  const behaviorsConfig: CustomElementConfig['behaviors'] = dashboardPageId
    ? {
        dashboard: {
          dashboardPageComponentId: dashboardPageId,
        },
      }
    : undefined;
  const defaultThumbnailPath = path.join(
    projectFolder,
    'src/assets',
    folder,
    'thumbnail.png'
  );

  const customElementConfig: CustomElementConfig = {
    $schema: 'https://dev.wix.com/wix-cli/schemas/custom-element.json',
    id: randomUUID(),
    name,
    width: {
      defaultWidth: 450,
      allowStretch: true,
    },
    height: {
      defaultHeight: 250,
    },
    installation: {
      autoAddToSite: true,
    },
    behaviors: behaviorsConfig,
    presets: [
      {
        id: randomUUID(),
        thumbnailUrl: normalizeGlobbyPattern(
          path.relative(cwd, defaultThumbnailPath)
        ),
      },
    ],
  };
  const customElementConfigJSON = toJsonString(customElementConfig, {
    spaces: 2,
  });

  return await componentGenerator({
    template: CUSTOM_ELEMENT_TEMPLATE,
    projectFolder,
    cwd,
    assetsOutputPath: path.join('src/assets', folder),
    data: {
      customElementConfigJSON,
      readablePath,
      name,
    },
  });
}
